/**
 * Customized colors.  Do NOT add any additional colors outside of
 * Design/Product team's consent.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 */

const colors = {
  primaryScale: {
    50: '#E3F3FF', // Solitude
    100: '#BBE0FF', // French Pass
    200: '#8ECEFF', // Anakiwa
    300: '#5DBAFF', // Malibu
    400: '#32AAFF', // Dodger Blue
    500: '#009BFF', // Azure
    600: '#008EFF', // Primary Blue
    700: '#0A79EB', // Blue Ribbon
    800: '#1068D9', // Denim
    900: '#1348BA' // Tory Blue
  },
  greyScale: {
    50: '#FFFFFF', // White
    75: '#F9FAFB', // Lightest to White
    100: '#F4F9FE', // Selago
    200: '#E9F1F7', // Black Squeeze
    300: '#C9DDEC', // Periwinkle
    400: '#AEC5D8', // Pigeon Post
    500: '#91AAC3', // Nepal
    600: '#7B96B2', // Wild Blue Yonder
    700: '#6484A2', // Hoki
    800: '#506C89', // Bismark
    900: '#1B3A59' // Nile Blue
  },
  success: {
    primary: {
      50: '#00B96D1A', // Jade Background
      300: '#59EC9C', // Jade Light
      600: '#00B96D', // Jade
      900: '#008841' // Jade Dark
    },
    secondary: {
      300: '#5CEFCB', // CaribbeanGreen Light
      600: '#00BC9A', // CaribbeanGreen
      900: '#008B6C' // CaribbeanGreen Dark
    }
  },
  caution: {
    primary: {
      50: '#FFA9001A', // Web Orange Background
      100: '#FFF4EC', // Web Orange Light Background
      300: '#FFDB4A', // Web Orange Light
      600: '#FFA900', // Web Orange
      900: '#C67A00' // Web Orange Dark
    },
    secondary: {
      300: '#FFC747', // Pizzazz Light
      600: '#FF9600', // Pizzazz
      900: '#C66700' // Pizzazz Dark
    }
  },
  error: {
    primary: {
      50: '#FF3B3F1A', // Coral Red Background
      300: '#FFCDD5', // Coral Red Light
      600: '#FF3B3F', // Coral Red
      900: '#C40017' // Coral Red Dark
    }
  },
  background: {
    main: '#F4F9FE', // Selago
    tray: '#E8EFFA',
    primaryArchived: '#E5F0F6',
    secondaryArchived: '#D6E6F0'
  },
  backgroundScale: {
    50: '#F4F9FE', // Selago
    100: '#E5F0F8', // Link Water
    200: '#D7E7F2', // Pattens Blue
    300: '#C6DBEA', // Columbia
    400: '#B6CEE0', // Ziggurat
    500: '#A6C3D8', // Light Steel
    600: '#96B0C3', // Nepal
    700: '#8399A9', // Bali Hai
    800: '#738491', // Slate
    900: '#5F6D77' // Nevada
  },
  white: '#FFFFFF',
  black: '#000000',

  gradient: {
    brandPrimary: 'linear-gradient(177.51deg, #1068D9 2.18%, #008EFF 59.96%, #5DBAFF 105.87%)', // PINS Blue
    brandSecondary: 'linear-gradient(89.06deg, #09B691 0.81%, #8FC844 99.19%)', // PINS Green
    primary: 'linear-gradient(295deg, #09C6F9 0%, #045DE9 100%)', // Rich Neighbor
    secondary: 'linear-gradient(108.54deg, #09203F 6.56%, #537895 95.2%)', // Calm Celebration
    general: 'linear-gradient(118.66deg, #48A9FE 15.1%, #0BEEF9 94.01%)', // TFW
    special: 'linear-gradient(114.41deg, #2A2A72 10.84%, #045DE9 36.58%, #09C6F9 66.69%, #02FFD1 94.62%)',
    success: 'linear-gradient(118.66deg, #03C8A8 15.1%, #89D8D3 94.01%)', // War Crime
    warning: 'linear-gradient(117.59deg, #FFDD00 0%, #FBB034 95.45%)', // Soda
    error: 'linear-gradient(109.6deg, #FF9966 17.44%, #FF5E62 78.63%)', // Fyre Festival
    buttonPrimary: 'linear-gradient(295deg, #045DE9 0%, #09C6F9 53%, #045DE9 110%)',
    buttonSuccess: 'linear-gradient(109.6deg, #09B691 0%, #8FC844 50%, #09B691 100%)',
    buttonError: 'linear-gradient(109.6deg, #FF9966 0%, #FF5E62 50%, #FF9966 100%)',
    aiPrimary: 'linear-gradient(135deg, #008CFF 0%, #5D56FA 28%, #7137F1 53%, #A334EC 80%, #D630E4 100%)',
    aiPrimaryOpaque: 'linear-gradient(\n'
      + '  118deg,\n'
      + '  rgba(0, 140, 255, 0.1) 0%,\n'
      + '  rgba(93, 86, 250, 0.1) 28%,\n'
      + '  rgba(113, 55, 241, 0.1) 53%,\n'
      + '  rgba(163, 52, 236, 0.1) 80%,\n'
      + '  rgba(214, 48, 228, 0.1) 100%\n'
      + ')'
  },

  avatarColors: {
    capri: '#30C5FF',
    heliotrope: '#9381FF',
    westSide: '#FF910A',
    sunglow: '#FFB800',
    puertoRico: '#00CABE',
    atlantis: '#9ACD32',
    zomp: '#32A287',
    seaweed: '#028090',
    matisse: '#2364AA',
    barbie: '#FF69B4',
    bittersweet: '#FF6B6B',
    radicalRed: '#FF3366',
    razzmatazz: '#D81159',
    smitten: '#BE3E82',
    camelot: '#8F2D56'
  }
};

export default colors;
